import type { ICountryDefinition } from "@/countries/country-common";

import { EAddressProvider } from "@/domains/address/providers/address-provider.types.ts";
import { ECountry, ECountryCode, ELanguageCode } from "@/domains/country/country.types.ts";

export const SPAIN_DATABASE_COUNTRY_ID = 11;

export const SpainCountryDefinition = {
  addressProvider: EAddressProvider.GOOGLE,
  countryCode: ECountryCode.SPAIN,
  languageCode: ELanguageCode.SPANISH,
  country: ECountry.SPAIN,
  phoneAllowed: true,
  addressAllowed: false,
  phone: {
    mask: "+34 999 99 99 99",
    placeholder: "+34 XXX XX XX XX",
    prefix: "+34",
  },
  databaseCountryId: SPAIN_DATABASE_COUNTRY_ID,
} as const satisfies ICountryDefinition;
